<div class="dashboard">
  
  <div class="row justify-content-end g-3 col-12 mx-auto mb-2">
    <!-- Facility -->
    <div class="col-12 col-sm-6 col-md-4 col-lg-3">
      <div class="form-group">
        <label class="form-label fw-medium">
          Facility<span class="text-danger">*</span>
        </label>
        <ng-select
          [items]="facilities"
          bindLabel="name"
          bindValue="id"
          placeholder="Select Facility"
          [clearable]="true"
          [searchable]="true"
          class="w-100 rounded"
          [(ngModel)]="selectedFacilityId"
          (change)="onFacilityChange($event)"
          (clear)="clearFacility()"
          >
        </ng-select>
      </div>
    </div>

    <!-- Floor -->
    <div class="col-12 col-sm-6 col-md-4 col-lg-3 p-0">
      <div class="form-group">
        <label class="form-label fw-medium">
          Floor<span class="text-danger">*</span>
        </label>
        <ng-select
          [items]="floors"
          bindLabel="name"
          bindValue="id"
          placeholder="Select Floor"
          [clearable]="true"
          [searchable]="true"
          class="w-100 rounded"
          [(ngModel)]="selectedFloorId"
          (change)="onFloorChange($event)"
          (clear)="clearFloor()"
           >
        </ng-select>
      </div>
    </div>

     <!-- Start Date -->
    <div class="col-12 col-sm-6 col-md-4 col-lg-2">
      <div class="form-group">
        <label class="form-label fw-medium">Start Date</label>
        <input type="date" 
               class="form-control rounded"
               [(ngModel)]="startDate"
               (change)="onDateChange()">
      </div>
    </div>

    <!-- End Date -->
    <div class="col-12 col-sm-6 col-md-4 col-lg-2">
      <div class="form-group">
        <label class="form-label fw-medium">End Date</label>
        <input type="date" 
               class="form-control rounded"
               [(ngModel)]="endDate"
               (change)="onDateChange()">
      </div>
    </div>
  </div>


  <!-- MAIN GRID -->
  <div class="grid">

    <!-- ALERTS CARD -->
    <div class="card alerts-card">
      <h3 class="me-auto fw-bold mb-1">Alerts</h3>
      <div class="alerts-content">
        <highcharts-chart
          class="chart"
          [Highcharts]="Highcharts"
          [options]="pieChartOptions"
           >
        </highcharts-chart>
      </div>
    </div>

    <!-- BAR CHART -->
    <div class="card">
      <h3 class="fw-bold mb-1">Number of Alerts</h3>

      <highcharts-chart
        [Highcharts]="Highcharts"
        [options]="barChartOptions"
        style="width: 100%; height: 300px; display: block;">
      </highcharts-chart>

    </div>

  </div>

  <!-- BOTTOM CARDS -->
  <!-- BOTTOM METRICS -->
  <div class="bottom-grid">

    <!-- MODEL ACCURACY -->
    <div class="card small">
      <p class="metric-label">Model accuracy per month</p>
      <h2 class="metric-value">{{ accuracy }}%</h2>
    </div>

    <!-- RESPONSE TIME -->
    <div class="card small">
      <p class="metric-label">Average response time</p>
      <h2 class="metric-value">{{ avgResponseTime }}</h2>
    </div>

    <!-- RESOLVE TIME -->
    <div class="card small">
      <p class="metric-label">Average resolve time</p>
      <h2 class="metric-value">{{ avgResolveTime }}</h2>
    </div>

  </div>

</div>